import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';
import Tooltip from 'react/components/Tooltip';

/**
 * Component to display size information
 * Single responsibility: Display size configuration information
 */
function SizeInfoDisplay({ sizeAliasConfigs }) {
  if (!sizeAliasConfigs?.length) {
    return null;
  }

  return (
    <Flex alignItems="center" gap={4} className="size">
      {sizeAliasConfigs.map(({ id, icon, description, sizeInfo }) => (
        <Flex key={id} alignItems="center" gap={4} className="size-item">
          <i className={icon} />
          <Tooltip
            title={`${description}:${sizeInfo.title}`}
            position="top-right"
          >
            <Text dataTestId={`size-item-${id}`} size="xs" weight="bold">
              {sizeInfo.size}
            </Text>
          </Tooltip>
        </Flex>
      ))}
    </Flex>
  );
}

SizeInfoDisplay.propTypes = {
  sizeAliasConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      icon: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      sizeInfo: PropTypes.shape({
        size: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      }).isRequired
    })
  )
};

SizeInfoDisplay.defaultProps = {
  sizeAliasConfigs: []
};

export default SizeInfoDisplay;
